import { render, staticRenderFns } from "./DropdownGroupEditor.vue?vue&type=template&id=0dac270e"
import script from "./DropdownGroupEditor.vue?vue&type=script&lang=js"
export * from "./DropdownGroupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports